// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14jZL","colMin":"styles_colMin__27oFj"};